/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScanEventDetailsQueryVariables = Types.Exact<{
  scanEventId: Types.Scalars['ID']['input'];
}>;


export type ScanEventDetailsQuery = { __typename?: 'Query', scanEvent?: { __typename?: 'ScanEvent', id: string, createdAt?: any | null, isContaminated?: boolean | null, isDamaged?: boolean | null, material?: Types.MaterialType | null, notes?: string | null, weight?: number | null, scanEventType?: Types.ScanEventType | null, contaminationAmount?: number | null, photos?: Array<{ __typename?: 'ScanEventPhoto', id: string, photoType?: Types.ScanEventPhotoType | null, photo?: { __typename?: 'GraphweaverMedia', url: string } | null }> | null, trackableAsset: { __typename?: 'TrackableAsset', id: string, docketId?: string | null, status?: Types.AssetStatus | null, scannableCode?: string | null, assetType?: Types.AssetType | null, truckRegistration?: string | null, containsTrackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, intendedMaterial?: Types.MaterialType | null, status?: Types.AssetStatus | null, assetType?: Types.AssetType | null, scannableCode?: string | null }> | null }, scanEventChanges?: Array<{ __typename?: 'ScanEventChanges', id: string, createdAt: any, user: { __typename?: 'User', contact: { __typename?: 'Contact', firstName?: string | null, lastName?: string | null } } }> | null } | null };

export type UpdateScanEventMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UpdateScanEventInput>;
}>;


export type UpdateScanEventMutation = { __typename?: 'Mutation', customUpdateScanEvent?: { __typename?: 'ScanEvent', id: string, createdAt?: any | null, isContaminated?: boolean | null, isDamaged?: boolean | null, weight?: number | null, material?: Types.MaterialType | null, notes?: string | null, scanEventType?: Types.ScanEventType | null, contaminationAmount?: number | null, photos?: Array<{ __typename?: 'ScanEventPhoto', id: string, photoType?: Types.ScanEventPhotoType | null, photo?: { __typename?: 'GraphweaverMedia', url: string } | null }> | null, trackableAsset: { __typename?: 'TrackableAsset', id: string, docketId?: string | null, status?: Types.AssetStatus | null, scannableCode?: string | null, assetType?: Types.AssetType | null, truckRegistration?: string | null, containsTrackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, intendedMaterial?: Types.MaterialType | null, status?: Types.AssetStatus | null, assetType?: Types.AssetType | null, scannableCode?: string | null }> | null } } | null };

export type AddEditScanEventPhotoMutationVariables = Types.Exact<{
  input: Types.ScanEventPhotoInsertInput;
}>;


export type AddEditScanEventPhotoMutation = { __typename?: 'Mutation', createScanEventPhoto?: { __typename?: 'ScanEventPhoto', id: string } | null };

export type FetchTrackableAssetsQueryQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TrackableAssetsListFilter>;
}>;


export type FetchTrackableAssetsQueryQuery = { __typename?: 'Query', trackableAssets?: Array<{ __typename?: 'TrackableAsset', id: string, assetType?: Types.AssetType | null, status?: Types.AssetStatus | null, scannableCode?: string | null } | null> | null };


export const ScanEventDetailsDocument = gql`
    query ScanEventDetails($scanEventId: ID!) {
  scanEvent(id: $scanEventId) {
    id
    createdAt
    isContaminated
    isDamaged
    material
    notes
    weight
    photos {
      id
      photoType
      photo {
        url
      }
    }
    scanEventType
    contaminationAmount
    trackableAsset {
      id
      docketId
      status
      scannableCode
      assetType
      truckRegistration
      containsTrackableAssets {
        id
        intendedMaterial
        status
        assetType
        scannableCode
      }
    }
    scanEventChanges {
      id
      createdAt
      user {
        contact {
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useScanEventDetailsQuery__
 *
 * To run a query within a React component, call `useScanEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanEventDetailsQuery({
 *   variables: {
 *      scanEventId: // value for 'scanEventId'
 *   },
 * });
 */
export function useScanEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<ScanEventDetailsQuery, ScanEventDetailsQueryVariables> & ({ variables: ScanEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanEventDetailsQuery, ScanEventDetailsQueryVariables>(ScanEventDetailsDocument, options);
      }
export function useScanEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanEventDetailsQuery, ScanEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanEventDetailsQuery, ScanEventDetailsQueryVariables>(ScanEventDetailsDocument, options);
        }
export function useScanEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanEventDetailsQuery, ScanEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanEventDetailsQuery, ScanEventDetailsQueryVariables>(ScanEventDetailsDocument, options);
        }
export type ScanEventDetailsQueryHookResult = ReturnType<typeof useScanEventDetailsQuery>;
export type ScanEventDetailsLazyQueryHookResult = ReturnType<typeof useScanEventDetailsLazyQuery>;
export type ScanEventDetailsSuspenseQueryHookResult = ReturnType<typeof useScanEventDetailsSuspenseQuery>;
export type ScanEventDetailsQueryResult = Apollo.QueryResult<ScanEventDetailsQuery, ScanEventDetailsQueryVariables>;
export const UpdateScanEventDocument = gql`
    mutation UpdateScanEvent($input: UpdateScanEventInput) {
  customUpdateScanEvent(input: $input) {
    id
    createdAt
    isContaminated
    isDamaged
    weight
    material
    notes
    photos {
      id
      photoType
      photo {
        url
      }
    }
    scanEventType
    contaminationAmount
    trackableAsset {
      id
      docketId
      status
      scannableCode
      assetType
      truckRegistration
      containsTrackableAssets {
        id
        intendedMaterial
        status
        assetType
        scannableCode
      }
    }
  }
}
    `;
export type UpdateScanEventMutationFn = Apollo.MutationFunction<UpdateScanEventMutation, UpdateScanEventMutationVariables>;

/**
 * __useUpdateScanEventMutation__
 *
 * To run a mutation, you first call `useUpdateScanEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScanEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScanEventMutation, { data, loading, error }] = useUpdateScanEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScanEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScanEventMutation, UpdateScanEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScanEventMutation, UpdateScanEventMutationVariables>(UpdateScanEventDocument, options);
      }
export type UpdateScanEventMutationHookResult = ReturnType<typeof useUpdateScanEventMutation>;
export type UpdateScanEventMutationResult = Apollo.MutationResult<UpdateScanEventMutation>;
export type UpdateScanEventMutationOptions = Apollo.BaseMutationOptions<UpdateScanEventMutation, UpdateScanEventMutationVariables>;
export const AddEditScanEventPhotoDocument = gql`
    mutation AddEditScanEventPhoto($input: ScanEventPhotoInsertInput!) {
  createScanEventPhoto(input: $input) {
    id
  }
}
    `;
export type AddEditScanEventPhotoMutationFn = Apollo.MutationFunction<AddEditScanEventPhotoMutation, AddEditScanEventPhotoMutationVariables>;

/**
 * __useAddEditScanEventPhotoMutation__
 *
 * To run a mutation, you first call `useAddEditScanEventPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditScanEventPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditScanEventPhotoMutation, { data, loading, error }] = useAddEditScanEventPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEditScanEventPhotoMutation(baseOptions?: Apollo.MutationHookOptions<AddEditScanEventPhotoMutation, AddEditScanEventPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditScanEventPhotoMutation, AddEditScanEventPhotoMutationVariables>(AddEditScanEventPhotoDocument, options);
      }
export type AddEditScanEventPhotoMutationHookResult = ReturnType<typeof useAddEditScanEventPhotoMutation>;
export type AddEditScanEventPhotoMutationResult = Apollo.MutationResult<AddEditScanEventPhotoMutation>;
export type AddEditScanEventPhotoMutationOptions = Apollo.BaseMutationOptions<AddEditScanEventPhotoMutation, AddEditScanEventPhotoMutationVariables>;
export const FetchTrackableAssetsQueryDocument = gql`
    query FetchTrackableAssetsQuery($filter: TrackableAssetsListFilter) {
  trackableAssets(filter: $filter) {
    id
    assetType
    status
    scannableCode
  }
}
    `;

/**
 * __useFetchTrackableAssetsQueryQuery__
 *
 * To run a query within a React component, call `useFetchTrackableAssetsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTrackableAssetsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTrackableAssetsQueryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTrackableAssetsQueryQuery(baseOptions?: Apollo.QueryHookOptions<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>(FetchTrackableAssetsQueryDocument, options);
      }
export function useFetchTrackableAssetsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>(FetchTrackableAssetsQueryDocument, options);
        }
export function useFetchTrackableAssetsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>(FetchTrackableAssetsQueryDocument, options);
        }
export type FetchTrackableAssetsQueryQueryHookResult = ReturnType<typeof useFetchTrackableAssetsQueryQuery>;
export type FetchTrackableAssetsQueryLazyQueryHookResult = ReturnType<typeof useFetchTrackableAssetsQueryLazyQuery>;
export type FetchTrackableAssetsQuerySuspenseQueryHookResult = ReturnType<typeof useFetchTrackableAssetsQuerySuspenseQuery>;
export type FetchTrackableAssetsQueryQueryResult = Apollo.QueryResult<FetchTrackableAssetsQueryQuery, FetchTrackableAssetsQueryQueryVariables>;